/** Worker で地形を生成する（docs/02_architecture.md 5 章） */
import type { WorldData } from '../core/world';
import type { TerrainRequest, TerrainResponse } from '../workers/terrain.worker';

export function loadWorld(
  seed: number,
  onProgress: (label: string, fraction: number) => void,
): Promise<WorldData> {
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('../workers/terrain.worker.ts', import.meta.url), { type: 'module' });
    worker.onmessage = (e: MessageEvent<TerrainResponse>) => {
      const msg = e.data;
      if (msg.type === 'progress') onProgress(msg.label, msg.fraction);
      else if (msg.type === 'done') {
        worker.terminate();
        resolve(msg.world);
      } else {
        worker.terminate();
        reject(new Error(msg.message));
      }
    };
    worker.onerror = (e) => {
      worker.terminate();
      reject(new Error(e.message));
    };
    worker.postMessage({ type: 'generate', seed } satisfies TerrainRequest);
  });
}
